import React, { useEffect, useState } from "react";
import { Table } from "antd";
// import { searchReceiptVoucher } from "../../../Redux/action/MasterAction";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { adminMainUrl } from "../../../Config";
import axios from "axios";
import { toast } from "react-toastify";
import AccountPagination from "../../Masters/AccountMaster/GroupMaster/AccountPagination";
import { useLocation, useNavigate } from "react-router-dom";
import { getAllMasterBranchIdAndName } from "../../../Redux/action/MasterAction";
import { Button, Modal } from "react-bootstrap";
import Beatloader from "../../../Common/Loaders/Beatloader";

// const columns = [
//   { title: "Voucher No", dataIndex: "voucher_id", key: "voucher_id" },
//   { title: "Date", dataIndex: "date", key: "date" },
//   { title: "Account Name", dataIndex: "account_name", key: "account_name" },
//   { title: "Type", dataIndex: "type", key: "type" },
//   { title: "Amount", dataIndex: "amount", key: "amount" },
//   { title: "Status", dataIndex: "status", key: "status" },
//   { title: "Reference", dataIndex: "reference", key: "reference" },
//   {
//     title: "Actions",
//     key: "actions",
//     render: () => (
//       <div className="d-flex gap-2">
//         <i className="far fa-eye cursor-pointer"></i>
//         <i className="far fa-file-pdf cursor-pointer"></i>
//         <i className="fas fa-print cursor-pointer"></i>
//         <i className="far fa-trash-alt cursor-pointer text-danger"></i>
//       </div>
//     ),
//   },
// ];


const VoucherProcessingReceiptVoucher = ({ setActiveTab }) => {
  const token = Cookies.get("token");
  const user_id = Cookies.get("flexichain_user_id");
  const [showModal, setShowModal] = useState(false);
  const [voucherDetails, setVoucherDetails] = useState(null);
  const [loadingDetails, setLoadingDetails] = useState(false);



  const getVoucherDetails = async (id) => {
    try {
      setLoadingDetails(true);

      const res = await axios.get(
        `${adminMainUrl}/api/account/receipt-voucher-details/${id}`,
        {
          headers: {
            "auth-token": Cookies.get("token"),
            user_id: Cookies.get("flexichain_user_id"),
          },
        }
      );

      setVoucherDetails(res.data.data);
      setShowModal(true);

    } catch (err) {
      toast.error("Failed to fetch voucher details");
    } finally {
      setLoadingDetails(false);
    }
  };

  const printVoucherDetails = async (id) => {
    try {
      setLoadingDetails(true);

      const res = await axios.get(
        `${adminMainUrl}/api/account/receipt-voucher-print/${id}`,
        {
          responseType: "blob",   // IMPORTANT
          headers: {
            "auth-token": Cookies.get("token"),
            user_id: Cookies.get("flexichain_user_id"),
          },
        }
      );

      // Create blob link
      const url = window.URL.createObjectURL(new Blob([res.data]));

      const link = document.createElement("a");
      link.href = url;

      link.setAttribute("download", "Receipt_Voucher.pdf"); // filename
      document.body.appendChild(link);

      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

    } catch (err) {
      console.log(err);
      toast.error("Failed to download voucher");
    } finally {
      setLoadingDetails(false);
    }
  };


  const printVoucherDetails2 = async (id) => {
  try {
    setLoadingDetails(true);

    const res = await axios.get(
      `${adminMainUrl}/api/account/receipt-voucher-print/${id}`,
      {
        responseType: "blob",
        headers: {
          "auth-token": Cookies.get("token"),
          user_id: Cookies.get("flexichain_user_id"),
        },
      }
    );

    const file = new Blob([res.data], { type: "application/pdf" });
    const fileURL = URL.createObjectURL(file);

    // open PDF in new tab
    window.open(fileURL, "_blank");

  } catch (err) {
    console.log(err);
    toast.error("Failed to open voucher");
  } finally {
    setLoadingDetails(false);
  }
};

  const columns = [
    {
      title: "Voucher No",
      dataIndex: "voucher_id",
      key: "voucher_id",
      width: 140,
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      // width: 110,
      // sorter: (a, b) => new Date(a.date) - new Date(b.date),
    },
    {
      title: "Account Name",
      dataIndex: "account_name",
      key: "account_name",
      ellipsis: true,
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      width: 100,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      align: "right",
      width: 140,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 100,
      render: (status) => (
        <span
          className={`
        badge 
        ${status === "Posted"
              ? "bg-success"
              : status === "Cancelled"
                ? "bg-danger"
                : "bg-warning"
            }
        `}
        >
          {status}
        </span>
      ),
    },
    {
      title: "Reference",
      dataIndex: "reference",
      key: "reference",
      ellipsis: true,
    },
    {
      title: "Actions",
      key: "actions",
      width: 140,
      align: "center",
      fixed: "right",
      render: (_, record) => (
        <div className="d-flex gap-3 justify-content-center">
          <i className="far fa-eye cursor-pointer text-primary"
            onClick={() => getVoucherDetails(record.original.id)}
          ></i>
          <i className="far fa-file-pdf cursor-pointer text-info" onClick={() => printVoucherDetails2(record.original.id)}></i>
          <i className="fas fa-print cursor-pointer text-secondary" onClick={() => printVoucherDetails(record.original.id)}></i>
          {/* <i className="far fa-trash-alt cursor-pointer text-danger"></i> */}
        </div>
      ),
    },
  ];

  const {
    loadingReceiptVoucher,
    ReceiptVoucher,
    ReceiptVoucherError,
    // ReceiptVoucherCurrentPage,
    // ReceiptVoucherTotalPage,
    ReceiptVoucherTotalData,
    MasterBranchName,
  } = useSelector((state) => state?.MasterReducer);

  const [receiptVoucherSearch, setReceiptVoucherSearch] = useState({
    from_date: "",
    to_date: "",
    voucher_type: "",
    branch: "",
    account_name: "",
    status: "",
    amount_from: "",
    amount_to: "",
  });

  const [ReceiptVoucherCurrentPage, setReceiptVoucherCurrentPage] = useState(1);
  const [ReceiptVoucherTotalPage, setReceiptVoucherTotalPage] = useState(0);
  const [dataSourcer, setDataSourcer] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const location = useLocation();
  const urlString = window.location.href;
  const url = new URL(urlString);
  const path = url.pathname.slice(1);
  const searchParams = url.search;
  const q = path + searchParams;
  const queryParams = new URLSearchParams(location.search);

  const searchReceiptVoucher = async (
    token,
    user_id,
    {
      page,
      search_text,
      from_date,
      to_date,
      voucher_type,
      branch_id,
      account_name_name,
      status,
      amount_from,
      amount_to,
    },
  ) => {
    const config = {
      headers: {
        "auth-token": token,
        user_id: user_id,
        "Content-Type": "application/json",
      },
    };

    let apiUrl = `${adminMainUrl}/api/account/receipt-voucher`;

    const queryParams = [];
    if (page !== undefined) queryParams.push(`page=${page}`);
    if (search_text) queryParams.push(`search_text=${search_text}`);
    if (from_date) queryParams.push(`from_date=${from_date}`);
    if (to_date) queryParams.push(`to_date=${to_date}`);
    if (voucher_type) queryParams.push(`voucher_type=${voucher_type}`);
    if (branch_id) queryParams.push(`branch_id=${branch_id}`);
    if (account_name_name)
      queryParams.push(`ledger_account_name=${account_name_name}`);
    if (status) queryParams.push(`status=${status}`);
    if (amount_from) queryParams.push(`amount_from=${amount_from}`);
    if (amount_to) queryParams.push(`amount_to=${amount_to}`);

    if (queryParams.length > 0) {
      apiUrl += `?${queryParams.join("&")}`;
    }

    try {
      const res = await axios.get(apiUrl, config);
      //  console.log("API Response:", res.data);

      // Transform data to match table columns
      const transformedData = res.data.data.map((item) => ({
        key: item.id, // required by AntD Table
        voucher_id: item.voucher_id,
        date: item.date ? new Date(item.date).toLocaleDateString() : "-",
        account_name: item.ledger_account_name || "—",
        type: item.voucher_type || item.payment_by || "—",
        amount: item.amount
          ? `₹ ${Number(item.amount).toLocaleString("en-IN")}`
          : "—",
        status: item.status || "—",
        reference: item.reference || "—",
        // You can keep original data if needed for actions
        original: item,
      }));

      setDataSourcer(transformedData);
      setReceiptVoucherCurrentPage(res.data.pagination.currentPage || 1);
      setReceiptVoucherTotalPage(res.data.pagination.totalPages || 0);
    } catch (error) {
      console.error("Error fetching receipt vouchers:", error);
    }
  };

  const onValueChange = (e) => {
    const { name, type, value, checked } = e.target;
    let finalValue = value;
    if (type === "number") {
      const num = Number(value);
      if (num <= 0) {
        finalValue = "";
      } else {
        finalValue = num;
      }
    }
    setReceiptVoucherSearch((pre) => ({
      ...pre,
      [name]: type === "checkbox" ? checked : finalValue,
    }));
  };

  const {
    from_date,
    to_date,
    voucher_type,
    branch,
    account_name,
    status,
    amount_from,
    amount_to,
  } = receiptVoucherSearch;
  const searchVoucher = () => {
    // console.log("receiptVoucherSearch", receiptVoucherSearch);

    if (from_date > to_date) {
      toast.error("From date cannot be greater than To date");
      return;
    }

    searchReceiptVoucher(token, user_id, {
      page: 1,
      from_date: from_date,
      to_date: to_date,
      voucher_type: voucher_type,
      branch_id: branch,
      account_name_name: account_name,
      status: status,
      amount_from: amount_from,
      amount_to: amount_to,
    });

    // dispatch(
    //   searchReceiptVoucher(token, user_id, {
    //     from_date: from_date,
    //     to_date: to_date,
    //     voucher_type: voucher_type,
    //     branch_id: branch,
    //     account_name_name: account_name,
    //     status: status,
    //     amount_from: amount_from,
    //     amount_to: amount_to,
    //     // page: 1,
    //   })
    // );
  };

  const clearForm = () => {
    setReceiptVoucherSearch({
      from_date: "",
      to_date: "",
      voucher_type: "",
      branch: "",
      account_name: "",
      status: "",
      amount_from: "",
      amount_to: "",
    });
  };

  useEffect(() => {
    if (token && user_id) {
      searchReceiptVoucher(token, user_id, { page: 1 });
      dispatch(getAllMasterBranchIdAndName(token, user_id));

    } else {
      toast.error("Please login to continue.");
      navigate(`/login?burl=${encodeURIComponent(q)}`);
    }
  }, [token, user_id]);

  const formatValue = (val) => {
    return val === null || val === undefined || val === "" ? "-" : val;
  };

  const formatDate = (date) => {
    return date ? new Date(date).toLocaleDateString() : "-";
  };

  const currencySymbol = voucherDetails?.currency_master?.currency_symbol || "₹";

  if(loadingDetails){return <Beatloader/>}

  return (
    <>
      <style>
        {`
          .padding-pt-9 {
            padding: 10px;
          }
        `}
      </style>

      <div className="card p-4">
        <h5 className="fw-semibold mb-3">Receipt Voucher Search</h5>
        <div className="row">
          {/* from_date */}
          <div className="col-12 col-sm-4 col-md-3 mb-4">
            <label className="form-label fw-medium">From Date</label>
            <input
              type="date"
              name="from_date"
              className="form-control bg-light"
              placeholder="Enter from date"
              onChange={onValueChange}
              value={receiptVoucherSearch.from_date}
            />
          </div>

          {/* to_date */}
          <div className="col-12 col-sm-4 col-md-3 mb-4">
            <label className="form-label fw-medium">To Date</label>
            <input
              type="date"
              name="to_date"
              className="form-control bg-light"
              placeholder="Enter to date"
              onChange={onValueChange}
              value={receiptVoucherSearch.to_date}
            />
          </div>

          {/* voucher_type */}
          <div className="col-12 col-sm-4 col-md-3 mb-4">
            <label className="form-label fw-medium">Voucher Type</label>
            <select
              name="voucher_type"
              className="form-select bg-light padding-pt-9"
              value={receiptVoucherSearch.voucher_type}
              onChange={onValueChange}
            >
              <option value="">Select Voucher Type</option>
              <option value="Bank">Bank</option>
              <option value="Cash">Cash</option>
            </select>
          </div>

          {/* branch */}
          <div className="col-12 col-sm-4 col-md-3 mb-4">
            <label className="form-label fw-medium">Branch</label>
            <select
              name="branch"
              className="form-select bg-light padding-pt-9"
              value={receiptVoucherSearch.branch}
              onChange={onValueChange}
            >
              <option value="">Select Branch</option>
              {MasterBranchName?.map((item, i) => (
                <option value={item.id}>{item.name}</option>
              ))}
            </select>
          </div>

          {/* account_name */}
          <div className="col-12 col-sm-4 col-md-3 mb-4">
            <label className="form-label fw-medium">Account Name</label>
            <input
              type="text"
              name="account_name"
              className="form-control bg-light"
              value={receiptVoucherSearch.account_name}
              onChange={onValueChange}
              placeholder="Account Name"
            />
          </div>

          {/* status */}
          <div className="col-12 col-sm-4 col-md-3 mb-4">
            <label className="form-label fw-medium">Status</label>
            <select
              name="status"
              className="form-select bg-light padding-pt-9"
              value={receiptVoucherSearch.status}
              onChange={onValueChange}
            >
              <option value="">Select Status</option>
              <option value="Posted">Posted</option>
              <option value="Draft">Draft</option>
              <option value="Cancelled">Cancelled</option>
            </select>
          </div>

          {/* amount_from */}
          <div className="col-12 col-sm-4 col-md-3 mb-4">
            <label className="form-label fw-medium">Amount From</label>
            <input
              type="number"
              name="amount_from"
              className="form-control bg-light"
              value={receiptVoucherSearch.amount_from}
              onChange={onValueChange}
              placeholder="0"
            />
          </div>

          {/* amount_to */}
          <div className="col-12 col-sm-4 col-md-3 mb-4">
            <label className="form-label fw-medium">Amount To</label>
            <input
              type="number"
              name="amount_to"
              className="form-control bg-light"
              value={receiptVoucherSearch.amount_to}
              onChange={onValueChange}
              placeholder="0"
            />
          </div>

          {/* ACTION BUTTONS */}
          <div className="d-flex flex-wrap gap-2 mt-3">
            <button
              onClick={() => searchVoucher()}
              className="btn btn-primary px-4"
            >
              <i className="fas fa-save me-1"></i> Search
            </button>

            <button
              onClick={() => clearForm()}
              className="btn btn-light border px-4"
            >
              <i className="fas fa-undo me-1"></i> Clear
            </button>

            <button className="btn btn-light border px-4">
              <i class="fa-solid fa-file-export"></i> Export
            </button>

            <button className="btn btn-danger px-4">
              <i class="fa-solid fa-filter"></i> Advanced Search
            </button>
          </div>
        </div>
      </div>
      {/* table */}
      <div className="card p-4">
        <div className="d-flex flex-wrap justify-content-between align-items-center">
          <h5 className="fw-semibold mb-3">Receipt Voucher Search</h5>
          <button className="btn btn-primary px-4" onClick={() => { setActiveTab("receipt_voucher_enter") }}>
            <i className="fas fa-save me-1"></i> New Voucher
          </button>
        </div>
        <div className="table-responsive custom-table query-list-table mt-4">
          <Table
            className="table datanew dataTable no-footer"
            // rowSelection={rowSelection}
            dataSource={dataSourcer}
            columns={columns}
            pagination={false}
          />
        </div>
        <AccountPagination
          currentPage={ReceiptVoucherCurrentPage}
          totalPages={ReceiptVoucherTotalPage}
          onPageChange={(page) => {
            searchReceiptVoucher(token, user_id, {
              page,
              from_date: from_date,
              to_date: to_date,
              voucher_type: voucher_type,
              branch_id: branch,
              account_name_name: account_name,
              status: status,
              amount_from: amount_from,
              amount_to: amount_to,
            });
          }}
        />
      </div>


      {/* VOucher details modal */}
      <Modal show={showModal} size="lg">
        <Modal.Body>
          {loadingDetails ? (
            <div className="text-center">Loading...</div>
          ) : voucherDetails ? (
            <div className="container-fluid">

              {/* BASIC INFO */}
              <h6 className="mb-3 text-primary">Basic Info</h6>
              <div className="row">
                <div className="col-md-6 mb-2">
                  <strong>Voucher No:</strong> {formatValue(voucherDetails.voucher_id)}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>Date:</strong> {formatDate(voucherDetails.date)}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>Status:</strong> {formatValue(voucherDetails.status)}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>Voucher Type:</strong> {formatValue(voucherDetails.voucher_type)}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>Reference:</strong> {formatValue(voucherDetails.reference)}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>Reference Number:</strong> {formatValue(voucherDetails.reference_number)}
                </div>
              </div>

              <hr />

              {/* ACCOUNT DETAILS */}
              <h6 className="mb-3 text-primary">Account Details</h6>
              <div className="row">
                <div className="col-md-6 mb-2">
                  <strong>Account Name:</strong> {formatValue(voucherDetails.ledger_account_name)}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>GST:</strong> {formatValue(voucherDetails.gst_tin)}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>State:</strong> {formatValue(voucherDetails.state)}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>Branch:</strong> {formatValue(voucherDetails.branch_master?.name)}
                </div>
              </div>

              <hr />

              {/* FINANCIALS */}
              <h6 className="mb-3 text-primary">Financials</h6>
              <div className="row">
                <div className="col-md-6 mb-2">
                  <strong>Amount:</strong> {currencySymbol} {formatValue(voucherDetails.amount)}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>Net Amount:</strong> {currencySymbol} {formatValue(voucherDetails.net_amount)}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>Total Amount:</strong> {currencySymbol} {formatValue(voucherDetails.total_amount)}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>Current Balance:</strong> {currencySymbol} {formatValue(voucherDetails.current_balance)}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>Exchange Rate:</strong> {formatValue(voucherDetails.exchange_rate)}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>FC Amount:</strong> {formatValue(voucherDetails.fc_amount)}
                </div>
              </div>

              <hr />

              {/* BANK DETAILS */}
              <h6 className="mb-3 text-primary">Bank Details</h6>
              <div className="row">
                <div className="col-md-6 mb-2">
                  <strong>Bank Name:</strong> {formatValue(voucherDetails.bank_name)}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>Cheque Number:</strong> {formatValue(voucherDetails.cheque_number)}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>Cheque Date:</strong> {formatDate(voucherDetails.cheque_date)}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>Bank Charges:</strong> {currencySymbol} {formatValue(voucherDetails.bank_charges)}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>Bank Amount:</strong> {currencySymbol} {formatValue(voucherDetails.bank_amount)}
                </div>
              </div>

              <hr />

              {/* TDS DETAILS */}
              <h6 className="mb-3 text-primary">TDS Details</h6>
              <div className="row">
                <div className="col-md-6 mb-2">
                  <strong>TDS Rate:</strong> {formatValue(voucherDetails.tds_rate)}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>TDS Amount:</strong> {currencySymbol} {formatValue(voucherDetails.tds_amount)}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>Total TDS Deducted:</strong> {currencySymbol} {formatValue(voucherDetails.total_tds_deducted)}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>TDS Account:</strong> {formatValue(voucherDetails.tds_account_name)}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>TDS Party:</strong> {formatValue(voucherDetails.tds_party_name)}
                </div>
              </div>

              <hr />

              {/* LOGISTICS */}
              <h6 className="mb-3 text-primary">Logistics</h6>
              <div className="row">
                <div className="col-md-6 mb-2">
                  <strong>Docket/Order No:</strong> {formatValue(voucherDetails.docket_number_or_order_number)}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>Shipper Name:</strong> {formatValue(voucherDetails.shipper_name)}
                </div>
              </div>

              <hr />

              {/* OTHER */}
              <h6 className="mb-3 text-primary">Other</h6>
              <div className="row">
                <div className="col-md-12 mb-2">
                  <strong>Narration:</strong> {formatValue(voucherDetails.narration)}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>Verified By:</strong> {formatValue(voucherDetails.verified_by)}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>Cash Book:</strong> {formatValue(voucherDetails.cash_book?.name)}
                </div>
              </div>

            </div>
          ) : (
            <div className="text-center text-danger">No Data Found</div>
          )}

          <div className="row">
            <div>
              <button className="btn btn-sm btn-primary" onClick={() => { setShowModal(false) }}>Close</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default VoucherProcessingReceiptVoucher;
